export default __webpack_public_path__ + "static/media/screen1.dd3668c6.png";